var devtoolsRegistry = {};
function registerDevtoolsFunction(key, fn) {
  devtoolsRegistry[key] = fn;
}
export {
  devtoolsRegistry,
  registerDevtoolsFunction
};
//# sourceMappingURL=registry.js.map
